import type { PersonalizedPrompt as PersonalizedPromptType } from "@medbillai/graphql-types";
import { Paragraph2, YStack } from "@medbillai/ui";
export type PersonalizedPromptProps = {
  prompt: PersonalizedPromptType;
  onPress: (text: string) => void;
};
export function PersonalizedPrompt({
  prompt,
  onPress
}: PersonalizedPromptProps) {
  const handlePress = () => onPress(prompt.text);
  return <YStack onPress={handlePress} br="$6" py="$3" pl="$3" pr="$2" backgroundColor="$surface0" width="$13" transition="200ms easeCubic" hoverStyle={{
    backgroundColor: "$surface0Hover"
  }} pressStyle={{
    backgroundColor: "$surface0Hover"
  }} gap="$2" alignItems="flex-start" cursor="pointer" data-sentry-element="YStack" data-sentry-component="PersonalizedPrompt" data-sentry-source-file="PersonalizedPrompt.tsx">
      <YStack flex={1} alignContent="flex-start" justifyContent="center" data-sentry-element="YStack" data-sentry-source-file="PersonalizedPrompt.tsx">
        <Paragraph2 flexShrink={1} color="$textDefault" data-sentry-element="Paragraph2" data-sentry-source-file="PersonalizedPrompt.tsx">
          {prompt.text}
        </Paragraph2>
      </YStack>
    </YStack>;
}